import { faList, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@ui';
import { AnimatePresence, motion } from 'framer-motion';
import { Selection } from './DataTable';
import { Statistic } from './types';

interface Props {
    statistics: Statistic;
    selection: Selection;
    setShowSelection: (state: boolean) => any;
    showSelection: boolean;
    handleDeselectAll: () => void;
}

export default function SelectionAssistant({
    statistics,
    // selection,
    showSelection,
    setShowSelection,
    handleDeselectAll
}: Props) {
    const hasSelectedItems =
        (typeof statistics?.selectedItems === 'number' && statistics?.selectedItems > 0) ||
        statistics?.selectedItems === 'all';

    return (
        <AnimatePresence>
            {hasSelectedItems && (
                <motion.div
                    animate={{ opacity: 1, y: 0 }}
                    initial={{ opacity: 0, y: 60, x: '-50%' }}
                    exit={{ opacity: 0, y: 60 }}
                    onClick={(e) => e.stopPropagation()}
                    className="tw-absolute tw-bottom-0 tw-left-1/2 tw-z-30 tw-bg-transparent tw-px-24 tw-py-4"
                >
                    <div className="tw-pointer-events-auto tw-flex tw-flex-col tw-items-center tw-gap-2 tw-rounded-2xl tw-border-2 tw-border-solid tw-border-accents-2 tw-bg-white tw-p-2 tw-shadow-xl">
                        <span className="tw-text-xl">
                            <span className="tw-mr-2 tw-font-semibold">
                                {statistics?.selectedItems === 'all' ? 'Alle' : statistics?.selectedItems}
                            </span>
                            <span className="tw-align-baseline tw-text-xs tw-font-light tw-text-accents-6">
                                &nbsp;Element{statistics?.selectedItems === 1 ? '' : 'e'} ausgewählt
                            </span>
                        </span>
                        <div className="tw-flex tw-items-center tw-gap-2">
                            <Button
                                size="xs"
                                flat={!showSelection}
                                disabled={statistics?.selectedItems === 'all'}
                                color="warning"
                                icon={<FontAwesomeIcon icon={faList} />}
                                onClick={() => setShowSelection(!showSelection)}
                            >
                                Auswahl {showSelection ? 'verbergen' : 'anzeigen'}
                            </Button>
                            <Button
                                flat
                                size="xs"
                                color="error"
                                disabled={showSelection}
                                icon={<FontAwesomeIcon icon={faTimes} />}
                                onClick={handleDeselectAll}
                            >
                                Alle abwählen
                            </Button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
